export default {
  seiyakuAnken: (state) => state.seiyakuAnken,
  commentItems: (state) => state.commentItems,
  searchConditions: (state) => state.searchConditions,
};
